import {AxiosInstance} from 'axios'

import {createHttpClient} from '../client'
import {
  BrowserBackendSelector,
  BrowserLoginFlow,
  BrowserLoginStorage,
  EnvAuthRequestProvider,
  getDefaultDFBackends
} from '../login'

export class ApiClient {
  static #axiosInstance: AxiosInstance | null = null
  static #loginStorage: BrowserLoginStorage | null = null
  static #loginFlow: BrowserLoginFlow | null = null
  private static initialize() {
    const backendSelector = new BrowserBackendSelector(getDefaultDFBackends())
    const selectedBackend = backendSelector.getSelectedBackend()

    ApiClient.#loginStorage = new BrowserLoginStorage(
      `HC-${process.env.REACT_APP_CLIENT_NAME}-${selectedBackend.NAME}`
    )

    const dfAuthRequestProvider = new EnvAuthRequestProvider(backendSelector)
    ApiClient.#loginFlow = new BrowserLoginFlow(
      ApiClient.#loginStorage,
      dfAuthRequestProvider,
      backendSelector
    )

    // API for all service requests going through api gateway
    ApiClient.#axiosInstance = createHttpClient({
      backendSelector: backendSelector,
      authRequestProvider: dfAuthRequestProvider,
      loginStorage: ApiClient.#loginStorage,
      loginFlow: ApiClient.#loginFlow
    })
  }

  public static get axiosInstance(): AxiosInstance {
    if (ApiClient.#axiosInstance === null) ApiClient.initialize()
    return ApiClient.#axiosInstance as AxiosInstance
  }
  public static get loginFlow(): BrowserLoginFlow {
    if (ApiClient.#loginFlow === null) ApiClient.initialize()
    return ApiClient.#loginFlow as BrowserLoginFlow
  }
}
